export const SCAN_STATS_ENGAGEMENT = '/api/v1/scan-stats/engagement';
